import React, { useEffect } from 'react';
import Gear from '../components/Gear';

const GearPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>
        {`
          #gear-page .inner {
            background-color: #2C2C2E;
          }
          #gear-page .wrapper.spotlight.style2:before {
            background-color: #2C2C2E;
          }
          #gear-page .wrapper.spotlight.style2:after {
            background-color: #2C2C2E;
          }
        `}
      </style>
      <div id="gear-page">
        <Gear hideHeader={true} hideBackgroundImages={true} compactMode={true} />
      </div>
    </>
  );
};

export default GearPage;
